<template>
  <div class="creek-shows-container">
    <creek-shows-nav :shows-nav-text="showsNavText" :page-selected="pageSelected"></creek-shows-nav>
    <div class="creek-shows-find" v-if="pageSelected == 'all'">
      <input type="text" v-model="findTerm" placeholder="Find a Show" />
    </div>
    <div v-if="showsByWeekday" class="creek-shows">
      <creek-show :data-show="Show" v-for="(Show, index) in showsForSelectedWeekday" :key="'show-'+index"></creek-show>
      <div class="shows-cartoon">
        <img :src="assets.cartoons.YDP" />
      </div>
    </div>
    <div v-if="!showsByWeekday" class="creek-shows" v-html="Creek.config.shows.router.loadingHTML"></div>
  </div>
</template>

<script type="text/javascript">

import mixins from '../util/mixins';
import lang from '../lang/eng';
import fecha from 'fecha';
import JSONP from 'jsonp';

import CreekShowsNav from './ShowsNav';
import CreekShow from './Show';

// Jaime Icons
import Cartoon_Icon_YDP from "../../../assets/img/jaime-icons/Icon_YDP.png";

export default {

  name: 'creek-shows',

  mixins: [mixins.routes],

  props: ['page-selected'],

  components: {
    'creek-shows-nav': CreekShowsNav,
    'creek-show': CreekShow
  },

  data () {

    return {

      // TODO: GET FROM CREEK MAIN
      showsByWeekday: null,

      showsNavText: lang.schedule,

      assets: {
        cartoons: {
          YDP: Cartoon_Icon_YDP
        }
      },

    }

  },

  computed: {
    weekdayNumber (){
      if (typeof this.$route.params.weekdayNumber != 'undefined') {
        return this.$route.params.weekdayNumber;
      }
      else{
        return this.getWeekdayNumberForToday()
      }
    },
    showsForSelectedWeekday () {
      if (!this.showsByWeekday) {
        return [];
      }
      else if(this.weekdayNumber) {
        return this.showsByWeekday[this.weekdayNumber].programs;
      }
    } 
  },
  methods: {

    fetchData () {
      
      var URL = this.Creek.config.content.baseURLForAPI + "/api/schedule";

      //Only get data if it doens't already exist
      if (this.showsByWeekday == null) {
        
        this.Creek.debug.log("Loading Vue.js route: show schedule");
        
        var _this = this;
        
        JSONP(URL, null, function (err, data) {
          if(err){
            this.Creek.debug.log(err);
          }
          _this.showsByWeekday = data;
        });

      }

      // this.setTitle(this.Creek.util.capitalizeFirstLetter(this.Creek.config.shows.showsName));
      // this.swapPageClass("shows");

    },

    getWeekdayNumberForToday() {

      var weekdayNumber = parseInt(fecha.format(new Date(), 'd'));

      if(weekdayNumber === 0){
        weekdayNumber = 7;
      }

      return weekdayNumber;

    }

  },
  created () {
    this.fetchData();
  },
}

</script>
